import { App, computed, Ref } from 'vue'
import { round, getFormattedTime, getFormattedDate, getFormattedDuration } from '@/api/tools'
import { store } from '@/store'

const milesPerKm = 0.621371192

export default (app: App) => {
  app.config.globalProperties.$filters = {

    distance(meters: number) {
      const km = meters / 1000      
      const user = store.user.get(state => state.user)
      const metric: Ref<boolean | null> = computed(() => user.value && user.value?.settings.units !== 'imperial')  
      const distance = computed(() => metric.value ? km : km * milesPerKm)
      return round(distance.value, 1).toLocaleString(user.value ? user.value?.settings.lang + '-DK' : 'da-DK') + (metric.value ? ' km' : ' mi')  
    },
    duration(seconds: number) {
      return getFormattedDuration(seconds)
    },
    time(seconds: number) {
      return getFormattedTime(seconds)
    },
    date(seconds: number) {
      return getFormattedDate(seconds)
    },
    localDate(dateStr: string) {
      const date = new Date(dateStr)
      const options_old: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('da-DK', options)
    }
  }
}